import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import ProductCategoryTable from '../components/ProductCategoryTable';

const ProductCategoryList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Categories</span>
      </Portal>
      {pageSize && <ProductCategoryTable />}
    </Card>
  );
};

export default ProductCategoryList;
